<template>
  <div class="sp-template">
    <div class="h-title">交易流水</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" size="small">
          <el-form-item>
            <el-form-item label="交易类型">
              <el-radio-group v-model="conditions.serviceType" @change="onSubmit" size="small">
                <el-radio-button v-if="in_configs(501) && !(billId!=''&&billId!=null)" label="充值"></el-radio-button>
                <el-radio-button v-if="in_configs(503)" label="服务扣款"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form-item>
          <el-form-item v-if="gone&&!(billId!=''&&billId!=null)" label="客户名称">
            <el-select v-model="conditions.ownerOrgName" filterable clearable placeholder="请选择客户" @change="onSubmit">
              <el-option v-for="item in ownerOrgNames" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="系统" v-if="!(billId!=''&&billId!=null)">
            <!-- clearable -->
            <el-select v-model="conditions.system" filterable  placeholder="请选择系统" @change="onSubmit">
              <el-option v-for="item in systems" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" v-if="!(billId!=''&&billId!=null)">
            <el-date-picker v-model.lazy="conditions.startTime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期" v-if="!(billId!=''&&billId!=null)">
            <el-date-picker v-model.lazy="conditions.endTime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="交易号" v-if="(billId===''||billId===null)">
            <el-input v-model.lazy="conditions.id" placeholder="交易号" clearable @change="onSubmit"></el-input>
          </el-form-item>
          <el-form-item v-if="conditions.serviceType == '服务扣款'" label="订单号">
            <el-input style="width: 300px;" v-model.lazy="conditions.number" type="textarea" placeholder="多个订单号用回车分割"></el-input>
          </el-form-item>
          <el-form-item label="状态" v-if="conditions.serviceType == '服务扣款' && isProvider">
            <el-select v-model="conditions.transactionStatus" placeholder="请选状态" @change="onSubmit">
              <el-option v-for="item in transactionStatus" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" v-if="conditions.serviceType == '充值' && isProvider">
            <el-select v-model="conditions.depositStatus" filterable clearable placeholder="请选状态" @change="onSubmit">
              <el-option v-for="item in depositStatus" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述" v-if="conditions.serviceType == '充值'">
            <el-select v-model="conditions.description" filterable clearable placeholder="请选描述" @change="onSubmit">
              <el-option v-for="item in descriptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button v-if="in_configs(504)" type="primary" @click="onSubmit">搜 索</el-button>
          </el-form-item>
          <el-button type="success" size="small" v-if="in_configs(505) && conditions.serviceType == '服务扣款'" @click="exportTransaction">导出服务扣款</el-button>
          <el-button type="success" size="small" v-if="in_configs(509) && conditions.serviceType == '充值' " @click="exportDeposit">导出充值记录</el-button>
          <el-button type="success" size="small" v-if="in_configs(506) && conditions.serviceType == '服务扣款' && isProvider && isManual" @click="batchUpdateStatus(1)">
            结算
          </el-button>
          <el-button type="success" size="small" v-if="in_configs(510) && conditions.serviceType == '充值' && isProvider" @click="batchUpdateStatus(2)">确认</el-button>

        </el-form>
        <!-- <div>
					<el-button size="small" class="el-button btn-cyan">生成账单</el-button>
				</div> -->
      </div>
      <!-- 充值和服务扣款 -->
      <el-table :data="tableData" v-if="conditions.serviceType !== '线下充值'" stripe ref="multipleTable" @selection-change="handleSelectionChange" show-summary :summary-method="getSummaries" :key="Math.random()">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="交易号"></el-table-column>
        <el-table-column v-if="conditions.serviceType == '服务扣款'" prop="refNumber" label="订单号" :key="Math.random()"></el-table-column>
        <el-table-column v-if="conditions.serviceType == '服务扣款'" prop="ownerOrgName" label="付款方" :key="Math.random()"></el-table-column>
        <el-table-column prop="providerOrgName" :label="conditions.serviceType == '服务扣款' ? '收款方' : '付款方' " width="250"></el-table-column>

        <el-table-column v-if="conditions.serviceType == '充值'" prop="accountRemark" label="付款账户" :key="Math.random()"></el-table-column>
        <el-table-column v-if="conditions.serviceType == '充值'" prop="bank" label="银行类型" :key="Math.random()"></el-table-column>
        <el-table-column v-if="conditions.serviceType == '充值'" prop="actualAccountTime" label="实际到账时间" :key="Math.random()"></el-table-column>

        <el-table-column prop="system" label="系统" :formatter="formatSytem"></el-table-column>
        <el-table-column prop="time" label="交易时间">
          <template slot-scope="scope">
            {{ scope.row.time | formatTime }}
          </template>
        </el-table-column>
        <el-table-column prop="serviceType" label="交易类型" :formatter="formatServiceType"></el-table-column>
        <el-table-column prop="currency" label="币种"></el-table-column>
        <el-table-column prop="amount" label="交易金额" sortable>
          <template slot-scope="scope">
            <span :class="[scope.row.serviceType === 'DEPOSIT' ? 'in' : 'out']">{{scope.row.amount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column v-if="conditions.serviceType == '充值' && isProvider" label="充值凭证">
          <template slot-scope="scope">
            <img :src="'data:image/png;base64,'+scope.row.voucherImg" v-if="scope.row.description !== '通联充值'" alt="充值凭证" width="60px" height="60px" style="cursor: pointer;" @click="checkImg()">
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column v-if="conditions.serviceType == '服务扣款' && isProvider" prop="status" label="状态" :formatter="formatStatus" :key="Math.random()"></el-table-column>
        <el-table-column v-if="conditions.serviceType == '充值' && isProvider" prop="status" label="状态" :formatter="formatStatus" :key="Math.random()"></el-table-column>
        <el-table-column v-if="conditions.serviceType == '服务扣款' && isProvider" prop="partialPayment" label="部分结算金额" width="70" :key="Math.random()"></el-table-column>
        <el-table-column v-if="conditions.serviceType == '服务扣款'" label="明细" width="60" :key="Math.random()">
          <template slot-scope="scope">
            <a v-if="in_configs(507)" @click.prevent="getTransactionDetail(scope.row.url)" target="_blank">
              <i class="iconfont icon-chakan2" title="查看"></i>
            </a>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="isProvider && isManual" width="70" :key="Math.random()">
          <template slot-scope="scope">
            <i class="el-icon-edit-outline" v-if="in_configs(508) && isProvider" @click="handleEdit(scope.row)" title="修改"></i>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="conditions.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="conditions.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNums">
      </el-pagination>
      <el-dialog :visible="dialogShow" :before-close="handleClose">
        <iframe :src="url" width="100%" height="700px" frameborder="0"></iframe>
      </el-dialog>
      <transition name="el-fade-in-linear">
        <div class="modal" v-show="imgDialogShow" @click="closeModal()">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="img-wrapper">
                <div class="close" @click="closeModal()">
                  <i class="el-icon-circle-close-outline"></i>
                </div>
                <img id="imgContent" src="" alt="" style="max-width: 800px; max-height: 800px;">
              </div>
            </div>
          </div>
        </div>
      </transition>
      <el-dialog title="修改状态" :visible.sync="dialogVisible" width="30%">
        <el-form :model="transactionForm" size="small" :rules="rules" ref="transactionForm">
          <el-form-item label="交易号：" :label-width="formLabelWidth">
            <span>{{transactionForm.id}}</span>
          </el-form-item>
          <el-form-item v-if="conditions.serviceType == '服务扣款'" label="付款方：" :label-width="formLabelWidth">
            <span>{{transactionForm.ownerOrgName}}</span>
          </el-form-item>
          <el-form-item label="收款方：" :label-width="formLabelWidth">
            <span>{{transactionForm.providerOrgName}}</span>
          </el-form-item>
          <el-form-item label="状态：" v-if="conditions.serviceType == '服务扣款'" :label-width="formLabelWidth">
            <el-select v-model="transactionForm.status">
              <el-option v-for="d in transactionStatus" :key="d.id" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：" v-if="conditions.serviceType == '充值' && isProvider" :label-width="formLabelWidth">
            <el-select v-model="transactionForm.status">
              <el-option v-for="d in depositStatus" :key="d.id" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="transactionForm.status == 'PARTIAL_PAYMENT'" label="结算金额：" :label-width="formLabelWidth" prop="partialPayment">
            <el-input v-model.lazy="transactionForm.partialPayment" placeholder="结算金额"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancel">取 消</el-button>
          <el-button size="small" type="primary" @click="updateStatus('transactionForm')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- <el-dialog :visible="imgDialogShow" id="imgContent">
        <div class="test"></div>
      </el-dialog> -->
    </el-card>
  </div>
</template>

<script>
// import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
import vm from "../../main.js";
import { mapMutations } from "vuex";
export default {
  data() {
    var checkAmount = (rule, value, callback) => {
      let ref = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (value == 0) {
        callback(new Error("结算金额不能为零"));
      } else if (value < 0) {
        callback(new Error("结算金额不能小于零"));
      } else if (!ref.test(value)) {
        callback(new Error("结算金额输入有误，小数最多保留两位"));
      } else {
        callback();
      }
    };
    return {
      isManual: false,
      show: true,
      gone: true,
      isProvider: true,
      billId: "",
      billSystemId: "",
      conditions: {
        id: "",
        orderIds: [],
        number: "",
        serviceType: "服务扣款",
        ownerOrgName: "",
        system: "TMS",
        startTime: this.getStartTime(),
        endTime: this.getEndTime(),
        transactionStatus: "",
        depositStatus: "",
        description: "",
        currentPage: 1,
        pageSize: 10
      },
      DEPOSIT: "充值",
      SERVICE_TRANSACTION: "服务扣款",
      systems: [
        {
          value: "TMS",
          label: "TMS物流系统"
        },
        {
          value: "WMS",
          label: "WMS仓库系统"
        },
        {
          value: "PP",
          label: "小包物流系统"
        }
      ],
      transactionForm: {
        id: "",
        status: "",
        partialPayment: ""
      },
      rules: {
        partialPayment: [
          { required: true, message: "请输入结算金额", trigger: "blur" },
          { validator: checkAmount, trigger: "blur" }
        ]
      },
      url: "",
      partialPayment: "",
      tableData: [],
      depositData: [],
      amount: 0,
      totalAmount: 0,
      multipleSelection: [],
      ownerOrgNames: [],
      transactionIds: [],
      transactionStatus: [
        { id: "NO_REIMBURSEMENT", name: "未结算" },
        { id: "HAS_BEEN_PAYMENT", name: "已结算" },
        { id: "PARTIAL_PAYMENT", name: "部分结算" }
      ],
      depositStatus: [
        { id: "UNCONFIRMED", name: "未确认" },
        { id: "CONFIRMED", name: "已确认" }
      ],
      auditStatus: [
        { id: "UNAUDITED", name: "未审核" },
        { id: "AUDITED", name: "已审核" }
      ],
      descriptions: [
        { id: "通联充值", name: "通联充值" },
        { id: "线下支付宝充值", name: "线下支付宝充值" },
        { id: "银行转账充值", name: "银行转账充值" },
        { id: "其他充值", name: "其他充值" }
      ],
      formLabelWidth: "120px",
      dialogShow: false,
      dialogVisible: false,
      imgDialogShow: false,
      isHasBeenPayment: false,
      totalNums: 0,
      pageSize: 10,
      currentPage: 1 //分页
    };
  },
  created() {
    if (this.$route.query.from === "bill/query") {
      let arr = [
        { id: 501, label: "充值" },
        { id: 502, label: "线下充值" },
        { id: 503, label: "服务扣款" },
        { id: 504, label: "搜索" },
        { id: 505, label: "导出服务扣款" },
        { id: 506, label: "结算" },
        { id: 507, label: "查看" },
        { id: 508, label: "修改" },
        { id: 509, label: "导出充值记录" },
        { id: 510, label: "确认" },
        { id: 511, label: "审核" }
      ];
      this.pageConfig = arr;
      sessionStorage.setItem("configs", JSON.stringify(arr));
    }
    this.billId = this.$route.query.id;
    this.billSystemId = this.$route.query.systemId;
    // console.log(">>>this.billId==", this.billId)

    setTimeout(() => {
      this.initOrgOwnerByOrgId();
      this.initTransaction();
      if (this.isProvider && this.billId === "") {
        this.offlineDeposit();
      }
    }, 500);
  },
  computed: {
    pageConfig: {
      get: function() {
        return this.$store.state.pageConfig;
      },
      set: function(value) {
        return this.setConfig(value);
      }
    }
  },
  filters: {
    formatTime(value) {
      if (!value) return "";
      return (
        new Date(value).getFullYear() +
        "-" +
        ("0" + (new Date(value).getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + new Date(value).getDate()).slice(-2) +
        " " +
        ("0" + new Date(value).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(value).getMinutes()).slice(-2) +
        ":" +
        ("0" + new Date(value).getSeconds()).slice(-2)
      );
    }
  },
  watch: {
    $route: function() {
      console.log(this.billId);
      this.billId = "";
      this.initOrgOwnerByOrgId();
      this.initTransaction();
    }
  },
  methods: {
    ...mapMutations({
      setConfig: "setPageConfig"
    }),
    selectTable(row, index) {
      if (row.status == "AUDITED") {
        return false;
      } else {
        return true;
      }
    },
    checkImg() {
      let src = event.target.src;
      if (src === "data:image/png;base64,null") {
        return;
      }
      this.imgDialogShow = true;
      var imgContent = document.getElementById("imgContent");
      imgContent.src = src;
    },
    closeModal() {
      this.imgDialogShow = false;
    },
    // 表尾合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "amount") {
          sums[index] =
            this.totalAmount == null ? 0 : this.totalAmount.toFixed(2); // 这个值应该是后台计算好返回到前台的
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    handleClose() {
      this.dialogShow = false;
    },
    getTransactionDetail(url) {
      console.log(url);
      if (!url || url === "") {
        this.$notify.warning({
          title: "提示",
          message: "当前交易暂无明细"
        });
        return;
      } else {
        this.dialogShow = true;
        this.url = url;
      }
    },
    formatServiceType(data) {
      switch (data.serviceType) {
        case "DEPOSIT":
          return "充值";
          break;
        case "SERVICE_TRANSACTION":
          return "服务扣款";
          break;
        case "WITHDRAWAL":
          return "取现";
          break;
      }
    },
    formatSytem(data) {
      switch (data.system) {
        case "TMS":
          return "TMS物流系统";
          break;
        case "WMS":
          return "WMS仓库系统";
          break;
        case "PP":
          return "小包物流系统";
          break;
      }
    },
    formatStatus(data) {
      if (this.conditions.serviceType == "服务扣款") {
        switch (data.status) {
          case "NO_REIMBURSEMENT":
            return "未结算";
            break;
          case "HAS_BEEN_PAYMENT":
            return "已结算";
            break;
          case "PARTIAL_PAYMENT":
            return "部分结算";
            break;
        }
      } else {
        switch (data.status) {
          case "UNCONFIRMED":
            return "未确认";
            break;
          case "CONFIRMED":
            return "已确认";
            break;
        }
      }
    },
    formatAuditStatus(data) {
      switch (data.status) {
        case "UNAUDITED":
          return "未审核";
          break;
        case "AUDITED":
          return "已审核";
          break;
      }
    },
    onSubmit() {
      this.conditions.currentPage = 1;
      if (this.conditions.serviceType === "充值") {
        this.conditions.orderIds = [];
      } else {
        this.conditions.description = "";
        this.conditions.orderIds = [];
        this.conditions.number.split(/\n+/gim).forEach((d, i) => {
          if (d && d != "") {
            this.conditions.orderIds.push(d);
          }
        });
      }
      this.initTransaction();
      this.transactionIds = new Array();
    },
    // 查询交易流水
    initTransaction() {
      if (this.billSystemId) {
        this.conditions.system = this.billSystemId;
      }
      // console.log(">>>>this.conditions___", this.conditions)
      this.$request1({
        method: 'POST',
        url: '/transaction/query',
        data: {
          id: this.conditions.id,
          orderIds: this.conditions.orderIds,
          startTime: this.conditions.startTime,
          ownerOrgName: this.conditions.ownerOrgName,
          // providerOrgName: this.conditions.providerOrgName,
          endTime: this.conditions.endTime,
          serviceType:
            this.conditions.serviceType === "充值"
              ? "DEPOSIT"
              : "SERVICE_TRANSACTION",
          system: this.conditions.system,
          currentPage: this.conditions.currentPage,
          pageSize: this.conditions.pageSize,
          billId: this.billId,
          status:
            this.conditions.serviceType === "充值"
              ? this.conditions.depositStatus
              : this.conditions.transactionStatus,
          hasBeenPayment: this.isHasBeenPayment,
          description: this.conditions.description
        }
      })
        .then(res => {
          // console.log(res.data);
          if (res.data.success) {
            if(res.data.data && res.data.data.transactionDtos != null) {
              this.tableData = res.data.data.transactionDtos;
              this.totalAmount = res.data.data.totalAmount;
              this.amount = res.data.data.totalAmount;
              this.totalNums = res.data.total;
              this.isProvider = this.tableData.length > 0 ? this.tableData[0].flag : false;
              this.isManual = res.data.data.isManual;
            }else{
              this.tableData = []
              this.totalAmount = 0
              this.amount = 0;
              this.totalNums = 0;
              this.isProvider = false;
              this.isManual = false;
            }            
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取当前组织ID 下所有的货主
    initOrgOwnerByOrgId() {
      this.$request1({
        method: 'GET',
        url: '/transaction/queryOrgOwner'
      })
        .then(res => {
          // console.log(res);
          if (res.data.success) {
            // console.log(res);
            this.gone = true;
            this.ownerOrgNames = res.data.data;
          } else {
            this.gone = false;
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    handleEdit(row) {
      // console.log(row);
      this.dialogVisible = true;
      this.transactionForm.id = row.id;
      this.transactionForm.ownerOrgName = row.ownerOrgName;
      this.transactionForm.providerOrgName = row.providerOrgName;
      this.transactionForm.status = row.status;
      this.transactionForm.partialPayment = row.partialPayment;
    },
    cancel() {
      this.transactionForm.id = "";
      this.transactionForm.status = "";
      this.transactionForm.partialPayment = "";
      this.dialogVisible = false;
    },
    batchUpdateStatus(status) {
      if (this.transactionIds.length == 0) {
        this.$message({
          message: "请选择交易流水",
          type: "error"
        });
        return;
      }
      this.transactionForm.id = this.transactionIds;
      let message = "";
      if (status == 1) {
        this.transactionForm.status = "HAS_BEEN_PAYMENT";
        this.transactionForm.partialPayment = 0;
        message = "是否结算选中订单";
      } else {
        this.transactionForm.status = "CONFIRMED";
        message = "是否确认选中充值";
      }
      if (
        this.transactionForm.status !== "HAS_BEEN_PAYMENT" &&
        this.transactionForm.partialPayment == 0
      ) {
        this.transactionForm.partialPayment = "";
      }
      console.log(this.transactionForm);
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'post',
            url: '/transaction/update',
            data: this.transactionForm
          })
            .then(res => {
              console.log(res);
              if (res.data.success) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.initTransaction();
                this.transactionIds = [];
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    updateStatus(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.transactionForm.partialPayment == 0) {
            this.transactionForm.partialPayment = "";
          }
          if (this.conditions.serviceType !== "充值") {
            if (
              this.transactionForm.status == "NO_REIMBURSEMENT" ||
              this.transactionForm.status == "HAS_BEEN_PAYMENT"
            ) {
              this.transactionForm.partialPayment = 0;
            }
          }

          this.$request1({
            method: 'GET',
            url: '/transaction/update',
            params: this.transactionForm
          })
            .then(res => {
              console.log(res);
              if (res.data.success) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.initTransaction();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(err => {
              console.log(err);
            });
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    // 导出服务扣款
    exportTransaction() {
      if (!this.conditions.system) {
        this.$notify({
          title: "提示",
          message: "请选择系统",
          type: "warning"
        });
        return false;
      }
      this.conditions.orderIds = [];
      this.conditions.number.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          this.conditions.orderIds.push(d);
        }
      });

      if (this.billId == undefined) {
        this.billId = "";
      }


      // this.$request1({
      //   method: 'post',
      //   url: `pda/export-carton-number`,
      //   params: {
      //     orderId: orderId
      //   }
      // }).then((res) => {
      //   if (res.success) {
      //     const link = document.createElement('a')
      //     let array = base64ToUint8Array(res.data)
      //     let blob = new Blob([array])
      //     link.style.display = 'none'
      //     link.href = URL.createObjectURL(blob)

      //     let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
      //     link.setAttribute('download', `fbaNumber_${orderId}_${timestr}.xlsx`)

      //     document.body.appendChild(link)
      //     link.click()
      //     document.body.removeChild(link)
      //   } else {
      //     this.$message.error('下载失败：' + res.data.message)
      //   }
      // })

      this.$windowOpen1(
        '/transaction/export' +
          "?txIds=" +
          this.transactionIds.toString() +
          "&id=" +
          this.conditions.id +
          "&orderIds=" +
          this.conditions.orderIds.toString() +
          "&ownerOrgName=" +
          this.conditions.ownerOrgName +
          "&system=" +
          this.conditions.system +
          "&startTime=" +
          this.conditions.startTime +
          "&endTime=" +
          this.conditions.endTime +
          "&status=" +
          this.conditions.transactionStatus.toString() +
          "&billId=" +
          this.billId
      );
    },
    // 导出充值记录
    exportDeposit() {
      this.$windowOpen1(
        '/transaction/exportDeposit' +
          "?txIds=" +
          this.transactionIds.toString() +
          "&ownerOrgName=" +
          this.conditions.ownerOrgName +
          "&system=" +
          this.conditions.system +
          "&startTime=" +
          this.conditions.startTime +
          "&endTime=" +
          this.conditions.endTime +
          "&status=" +
          this.conditions.depositStatus +
          "&description=" +
          this.conditions.description
      );
    },
    // 多选
    handleSelectionChange(val) {
      this.totalAmount = 0;
      this.multipleSelection = val;
      this.transactionIds = new Array();
      if (this.conditions.serviceType == "线下充值") {
        val.forEach((item, index) => {
          if (item.status == "UNAUDITED") {
            this.transactionIds.push(item.id);
          }
          this.totalAmount += item.amount;
        });
        if (val.length == 0) {
          this.totalAmount = this.amount;
        }
      } else {
        val.forEach((item, index) => {
          this.transactionIds.push(item.id);
          this.totalAmount += item.amount;
        });
        if (val.length == 0) {
          this.totalAmount = this.amount;
        }
      }
    },
    //分页
    handleSizeChange(val) {
      this.conditions.pageSize = val;
      this.conditions.currentPage = 1;
      if (this.conditions.serviceType == "线下充值") {
        this.offlineDeposit();
      } else {
        this.initTransaction();
      }
    },
    handleCurrentChange(val) {
      this.conditions.currentPage = val;
      if (this.conditions.serviceType == "线下充值") {
        this.offlineDeposit();
      } else {
        this.initTransaction();
      }
    },
    getStartTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = (Array(2).join(0) + (date.getMonth() + 1)).slice(-2);
      let day = (Array(2).join(0) + date.getDate()).slice(-2);
      month = parseInt(month) - 1;
      if (month == 0) {
        year = parseInt(year) - 1;
        month = 12;
      }
      let days = new Date(year, month, 0);
      if (day > days.getDate()) {
        day = days.getDate();
      }
      return year + "-" + month + "-" + day;
    },
    getEndTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = (Array(2).join(0) + (date.getMonth() + 1)).slice(-2);
      let day = (Array(2).join(0) + date.getDate()).slice(-2);
      return year + "-" + month + "-" + day;
    }
  }
};
</script>

<style lang="scss" scoped>
.in {
  color: #78c9a4;
}
.out {
  color: #eca6af;
}
.iconfont {
  font-size: 12px;
  &:hover {
    cursor: pointer;
    color: #74beff;
  }
}
.modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2000;
  .modal-dialog {
    width: 100%;
    margin: 15% auto;
    transition: transform 0.3s ease-out;
    transform: translateY(-25%);
    .modal-content {
      position: relative;
      text-align: center;
      overflow: hidden;
      .img-wrapper {
        position: relative;
        display: inline-block;
        padding: 30px;
        .close {
          position: absolute;
          top: -5px;
          right: -30px;
          font-size: 30px;
          color: #f5f5f5;
          cursor: pointer;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/transaction/transaction.vue